import { useCallback, useState } from 'react'

export const useClipboard = () => {
  const [copied, setCopied] = useState(false)
  const copyText = useCallback((text: string) => {
    try {
      navigator.clipboard.writeText(text)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {}
  }, [])
  return { copied, copyText }
}

